"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPartRecipeTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsExport = require("../DmsExport/DmsExport");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsRecipeTable.
 * Renders a DmsTable with part recipe datas
 * @component
 * @example
 * return (
 *   <DmsPartRecipeTable />
 * )
 */

const DmsPartRecipeTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("RecipePart").d("Recipe part"),
    column_name: "recipe",
    form_column_name: "recipe_pk",
    function: recipe => (recipe || {}).name,
    control: 'select',
    url: "/recipe/all",
    properties: {
      column_name: 'name',
      filter: {
        value: "pk",
        field: "recipe_pk"
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Part").d("Part"),
    column_name: "part",
    function: part => (part || {}).name,
    form_column_name: "part_pk",
    control: 'select',
    url: "/part/all",
    properties: {
      column_name: "name",
      filter: {
        value: "pk",
        field: "part_pk"
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    width: "80px",
    sortable: false,
    element: row => {
      const recipe_name = row.recipe.name;
      const part_name = row.part.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateRecipePart", {
          recipe_name
        }, {
          part_name
        }).d("Update relation between {recipe_name} and {part_name}"),
        url: "/part_recipe",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteRecipePart", {
          recipe_name
        }, {
          part_name
        }).d("Delete relation between {recipe_name} and {part_name}"),
        text: _reactIntlUniversal.default.get("RecipePart.DeleteMensage").d("Delete relation relation between {recipe_name} and {part_name}. Are you sure about it?"),
        url: "/part_recipe",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateRecipePart").d("Createrecipe part relation"),
    url: '/part_recipe',
    header: header
  }))));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "part_recipe/table",
    responsive: true,
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }));
};
exports.DmsPartRecipeTable = DmsPartRecipeTable;